import React, { Component } from 'react'
import PropTypes from 'prop-types'

class NoInformationPanel extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		if (this.props.title) {
			return (
                <div className='card-padding'>
                    <div className='card-title no-margin'>
                        <h6 className='aquadb-title'>{ this.props.title }</h6>
                    </div>
				</div>
			)
		}
		return null
	}
}

NoInformationPanel.propTypes = {
	title: PropTypes.string.isRequired
}
NoInformationPanel.defaultProps = {
	title: 'Aucune information disponible'
}
export default NoInformationPanel



// WEBPACK FOOTER //
// ./src/point/components/util/NoInformationPanel.js